export const LOGLEVEL = {
  debug: 1,
  info: 2,
  warn: 3,
  error: 4,
};

export class ApiInterval {
  constructor(timerId, interval = 60, api = null, callback = null) {
    // if interval less than 3, set to 3
    if (interval < 3) {
      if(this.logLevel <= LOGLEVEL.warn) console.warn(`FailSafe Triggered: ApiInterval ${timerId} interval less than 3, set to 3`);
      interval = 3;
    }

    this.interval = interval;
    this.api = api || function () {
      if(this.logLevel <= LOGLEVEL.info) console.log(`ApiInterval Api ${timerId} executed`)
    };
    this.callback = callback || function () {
      if(this.logLevel <= LOGLEVEL.info) console.log(`ApiInterval callback ${timerId} executed`)
    };
    this.timerId = timerId;
    this.isRunning = false;
    this.logLevel = LOGLEVEL.info;
  }

  toString() {
    return this.timerId;
  }
}

class ApiIntervalPolling {
  constructor(logLevel = LOGLEVEL.debug) {
    this.logLevel = logLevel;

    this.interval = 1 // seconds
    this.apis = new Map();

    this.timer = null;
    this.nextRefreshTime = null;
    this.intervalData = null;
    this.elapsed = 0;
  }

  register(apiInterval) {
    if (!(apiInterval instanceof ApiInterval)) {
      throw new Error('Invalid ApiInterval instance');
    }
    // check if already registered
    if (this.apis.has(apiInterval.timerId)) {
      throw new Error(`ApiInterval with timerId ${apiInterval.timerId} is already registered`);
    }
    apiInterval.logLevel = this.logLevel;
    if(this.logLevel <= LOGLEVEL.info) console.log(`ApiIntervalPolling: Registered ApiInterval with timerId ${apiInterval.timerId} and interval ${apiInterval.interval} seconds`);
    this.apis.set(apiInterval.timerId, apiInterval);
    this.start(); // restart to recalculate interval table
  }

  remove(timerId) {
    this.apis.delete(timerId);
    this.start(); // restart to recalculate interval table
  }

  calculateIntervalTable() {
    const intervalTable = {};
    const highestInterval = Math.max(...Array.from(this.apis.values()).map(api => api.interval));
    const lowestInterval = Math.min(...Array.from(this.apis.values()).map(api => api.interval));
    const sumInterval = Array.from(this.apis.values()).reduce((sum, api) => sum + api.interval, 0);

    const maxInterval = Math.ceil(highestInterval/lowestInterval)*lowestInterval

    for (let time = lowestInterval; time <= maxInterval; time += lowestInterval) {
      intervalTable[time] = {};
      this.apis.forEach((apiInterval) => {
        intervalTable[time][apiInterval.toString()] = null

        let currentApiInterval = apiInterval.interval;
        // Prevent overlapping intervals
        if (currentApiInterval % lowestInterval === 0) {
          currentApiInterval--
        }

        if (((time % currentApiInterval) < lowestInterval)) {
          intervalTable[time][apiInterval.toString()] = 1;
        }
      })
    }
    return {
      intervalTable,
      interval: lowestInterval
    }
  }

  start() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if (this.apis.size === 0) {
      if(this.logLevel <= LOGLEVEL.info) console.log('ApiIntervalPolling: No registered APIs, Polling stopped');
      return;
    }
    this.intervalData = this.calculateIntervalTable();
    this.nextRefreshTime = $this.$moment().add(this.intervalData.interval, 'seconds');
    if(this.logLevel <= LOGLEVEL.info) console.table(this.intervalData.intervalTable);
    this.timer = setInterval(() => {
      if(this.logLevel <= LOGLEVEL.info) console.log('ApiIntervalPolling tick at', $this.$moment().format('HH:mm:ss'), 'Next refresh time at', this.nextRefreshTime ? this.nextRefreshTime.format('HH:mm:ss') : 'N/A');
      this.tick();
    }, 1 * 1000);
  }

  async tick() {
    if (!this.nextRefreshTime)
      return
    if ($this.$moment() < $this.$moment(this.nextRefreshTime))
      return;

    this.nextRefreshTime = null;
    let currentIntervals = this.intervalData.intervalTable[this.elapsed];
    if (!currentIntervals) {
      this.elapsed = this.intervalData.interval
      currentIntervals = this.intervalData.intervalTable[this.elapsed];
    }


    try {
      await this.do(currentIntervals);
    } catch (e) {
      if(this.logLevel <= LOGLEVEL.error) console.error('ApiIntervalPolling tick error:', e);
    } finally {
      this.elapsed += this.intervalData.interval;
      this.nextRefreshTime = $this.$moment().add(this.intervalData.interval, 'seconds');
    }
  }

  // for OVERWRITE
  async do(currentIntervals) {

  }

}

function main() {
  const Polling = new ApiIntervalPolling();
  // Polling.register(new ApiInterval('base', 10));
  // Polling.register(new ApiInterval('api1', 13));
  // Polling.register(new ApiInterval('api2', 60));
  // Polling.register(new ApiInterval('api3', 45));

  Polling.register(new ApiInterval('api1', 3));
  Polling.register(new ApiInterval('api2', 10));
  // Polling.register(new ApiInterval('api3', 45));

  console.table(Polling.calculateIntervalTable().intervalTable);
  Polling.do = async function (currentIntervals) {
    if(this.logLevel <= LOGLEVEL.info) console.log(`ApiIntervalPolling tick at elapsed ${this.elapsed} seconds`);
    if(this.logLevel <= LOGLEVEL.info) console.log(currentIntervals)
    // DEBUG: sleep 10
    await new Promise(resolve => setTimeout(resolve, 10 * 1000));
  }
  Polling.start();
}
// main()

export default {
  install(app) {
    const Polling = new ApiIntervalPolling(
      import.meta.env.VITE_NODE_ENV === 'production' ? LOGLEVEL.warn : LOGLEVEL.debug
    );
    Polling.do = async function (currentIntervals) {
      const apisToCall = {};
      if(this.logLevel <= LOGLEVEL.debug) console.log(currentIntervals)
      for (const [timerId, flag] of Object.entries(currentIntervals)) {
        if(!flag) continue;
        const apiInterval = this.apis.get(timerId);
        if(!apiInterval) {
          if(this.logLevel <= LOGLEVEL.warn) console.warn(`ApiInterval with timerId ${timerId} not found`);
          continue;
        }
        const apiData = apiInterval.api();
        if(!apiData) continue;
        apisToCall[timerId] = {
          api: apiData.api,
          input: apiData.input
        };
      }

      // if apisToCall is not empty
      if (Object.keys(apisToCall).length === 0) {
        return;
      }
      if(this.logLevel <= LOGLEVEL.debug) console.log({apisToCall})
      const result = await $this.$api.postData({
        data: apisToCall
      }, false)
      await new Promise(resolve => setTimeout(resolve, 5 * 1000));

      for (const [timerId, flag] of Object.entries(currentIntervals)) {
        if(!flag) continue;
        const apiInterval = this.apis.get(timerId);
        if(!apiInterval) {
          if(this.logLevel <= LOGLEVEL.warn) console.warn(`ApiInterval with timerId ${timerId} not found`);
          continue;
        }
        apiInterval.callback(result)
      }
    }

    app.config.globalProperties.$apiIntervalPolling = Polling;
  },
};
